/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

const IndustrySubMenuContainer = styled.div`
  @media (min-width: 1241px) {
    background: var(--white-color);
    border: 1px solid #e9eff2;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    position: absolute;
    padding: 0;
    transition: opacity 0.1s;
    z-index: 2147483647 !important;
    max-width: 1018px;
    width: auto;
    left: 10%;
    visibility: hidden;
    opacity: 0;
    margin-top: -20px;
    transition: all 0.25s ease-out;
    pointer-events: none;
  }

  .industry-sub-menu--container {
    padding: 30px;
    display: flex;
    width: 100%;

    .industry-sub-menu--group-container {
      flex: 1;

      .industry-sub-menu--sub-title {
        font-weight: 900;
        font-size: 14px;
        line-height: 110%;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: var(--normal-title-color);
        margin-bottom: 0;
        padding: 0 0 0 10px;
      }

      .industry-sub-menu--menu-content {
        list-style: none;
        margin: 0;
        padding: 15px 0 0;
        display: flex;
        flex-flow: column wrap;
        width: 220px;

        & > div {
          flex: none;
          padding: 0 !important;

          &.mobile-view-only {
            display: none;
            @media (max-width: 1240px) {
              display: block;
            }
          }
        }

        .mega-menu-item {
          vertical-align: middle;
          margin-right: 5px;
          width: 220px;

          a {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 10px;
            border-radius: 4px;

            &:hover {
              background: var(--blue-fourth);
            }

            .mega-menu-item--icon {
              border: none;
              width: 40px;
              height: 40px;
              margin-right: 10px;

              img {
                width: 100%;
                height: 100%;
              }
            }
            .mega-menu-item--content {
              padding: 0;
              align-self: center;

              .mega-menu-item--title {
                font-family: Sofia Pro;
                font-size: 16px;
                line-height: 20px;
                color: var(--normal-title-color);
                margin: 0;
                padding: 0;
                min-height: 40px;
                display: flex;
                align-items: center;
              }
              .mega-menu-item--description {
                font-family: Sofia Pro;
                font-size: 15px;
                line-height: 21px;
                color: #71848c;
                margin: 0;
              }
            }
          }
        }
      }

      &.group-industry {
        flex: 2;
        max-width: 660px;

        .industry-sub-menu--menu-content {
          width: ${props => `${props.industryGroupCols * 220}px`};
          height: ${props => `${props.industryGroupRows * 60 + 15}px`};
        }
      }
    }
  }

  @media (max-width: 1240px) {
    visibility: hidden;
    opacity: 0;
    transition: max-height 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    margin-top: 0 !important;
    flex-direction: column;

    .industry-sub-menu--container {
      padding: 10px 15px 0;
      flex-direction: column;

      .industry-sub-menu--group-container {
        padding-left: 0;
        padding-bottom: 20px;

        .industry-sub-menu--menu-content {
          padding: 10px 0 0;

          & > div {
            flex: 0 0 100%;
            width: 100%;
          }

          .mega-menu-item {
            max-width: 100%;

            a {
              &:hover {
                background: var(--white-color);
                .mega-menu-item--content {
                  .mega-menu-item--title {
                    color: var(--neutral-text-color);
                  }
                }
              }
              .mega-menu-item--content {
                .mega-menu-item--description {
                  display: none;
                }
              }
            }
          }
        }

        &.group-industry {
          max-width: 100%;

          .industry-sub-menu--menu-content {
            width: 100%;
            height: 100%;
          }
        }

        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
`;

const IndustrySubMenuFooterContainer = styled.div`
  background: #fbfbfb;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .simple-menu-item {
    margin: 0;
    padding: 0;

    p {
      font-weight: bold;
    }

    &:hover {
      background: transparent;

      p {
        color: var(--neutral-text-color) !important;
      }
    }
  }

  .industry-sub-menu--footer-demo {
    display: flex;
    padding-left: 10px;

    p,
    a {
      font-weight: bold;
      font-size: 17px;
      line-height: 33px;
      color: var(--normal-title-color) !important;
      margin: 0;
    }

    a {
      margin-left: 5px;
      text-decoration: underline;

      &:hover {
        color: var(--neutral-text-color) !important;
      }
    }
  }

  @media (max-width: 1240px) {
    flex-direction: column;
    padding-left: 20px;
    margin-bottom: 10px;

    .industry-sub-menu--footer-demo {
      display: none;
    }
  }
`;

export { IndustrySubMenuContainer, IndustrySubMenuFooterContainer };
